<template>
  <div class="tin-tview">
    <div class="tin-tview-box-left">
      <div class="tin-header"
           @click="$router.push('/')">
        <!-- <img src="/newLogo.png" alt /> -->
        <span></span>
      </div>
      <ul>
        <li v-for="(item, index) in tViewMenu"
            :class="{
            active: showTopMenu(item),
          }"
            :key="index"
            @click="onClick(item)">
          <span class="tu-icon"
                v-html="item.meta.icon"></span>
          <span class="tu-menu-item-text">{{ item.meta.title }}</span>
        </li>
      </ul>
    </div>
    <div class="tin-right">
      <div class="tin-mini-menu"
           @click="$router.push({name: 'introduction'})"
           v-if="!isClient">
        <span class="tu-icon">&#xe600;</span>
      </div>

      <div class="tin-user">
        <img src="data:image/png;base64,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"
             alt />
        <div class="tin-user-info">
          <span>{{ userName }}</span>
          <!-- <br /> -->
          <!-- <div class="tin-user-tag"><span>{{ getUserInfo().typeS }}</span></div> -->
        </div>
        <div class="tin-user-info-boxs">
          <div class="tin-user-info-box">
            <img src="data:image/png;base64,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"
                 alt />
            <span>{{ userName }}</span>
            <!-- <div class="tin-user-tag">{{ getUserInfo().typeS }}</div> -->
            <div style="margin-top:10px;">
              <el-button size="mini"
                         type="primary"
                         plain
                         @click="changePassword"
                         style="width:100%">个人信息</el-button>
            </div>
            <div style="margin-top:5px;">
              <el-button @click="loginOut"
                         plain
                         style="width:100%"
                         type="danger"
                         size="mini">退出登录</el-button>
            </div>
            <!-- <div class="tin-user-buttom color1"
                 @click="changePassword">账号信息</div> -->
            <!-- <div class="tin-user-buttom"
                 @click="loginOut">退出登录</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TView",
  props: {
    tViewMenu: Array,
  },
  data () {
    return {
      isClient: false,
      userName: ""
    };
  },
  methods: {
    onClick (item) {
      // console.log("item", item)

      let defaultActive = item.meta.default
      this.$emit('transDefault', { active: defaultActive + '', name: item.meta.title })
      this.$router.push(item.toPath);
    },
    changePassword () {
      this.$router.push({
        name: "accountInfo",
      });
    },
    loginOut () {
      localStorage.removeItem("auth");
      location.assign("/");
    },
    showTopMenu (e) {
      for (const item of e.children) {
        if (item.name === this.$route.name) {
          return true;
        } else {
          if ("children" in item) {
            return this.showTopMenu(item);
          }
        }
      }
    },
  },
  created () {
    // this.getUserInfo((info) => {

    // })
    this.$get("/bh/jk/account/userinfo").then(res => {
      this.userName = res.data.userName;
    })


    if (typeof election === "undefined") {
      return;
    } else {
      this.isClient = true
    }
  }
};
</script>
 
<style  lang="scss" scoped>
.tin-tview {
  user-select: none;
  width: 100%;
  height: 100%;
  background-color: #4caf50;
  /* box-shadow: 0 0 1px 0px rgba(0, 0, 0, 0.15); */
  font-size: 14px;
  z-index: 100;
  display: flex;
  justify-content: space-between;
}

.tin-tview-box-left {
  display: flex;
}

.tin-header {
  height: 100%;
  // width: 200px;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  justify-content: left;
  align-items: center;
  color: #fff;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.tin-header img {
  display: block;
  width: 30px;
  background-color: #fff;
  border-radius: 30px;
  margin: 0 10px 0 20px;
  padding: 2px;
}

.tin-header span {
  font-size: 22px;
}

ul {
  display: flex;
  list-style: none;
  height: 100%;
  margin: 0;
}

li {
  display: flex;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
  height: 100%;
  /* line-height: 50px; */
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  color: #fff;
}

li:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

// li::before {
//   position: absolute;
//   content: "";
//   width: 0;
//   height: 0;
//   border: 6px solid transparent;
//   border-color: #37803a transparent transparent transparent;
//   bottom: 0;
//   left: 50%;
//   margin: 0 0 -12px -6px;
//   z-index: 1;
// }

li.active {
  background-color: rgba(0, 0, 0, 0.28);
  overflow: inherit;
  color: #fff;
}
.tin-right {
  display: flex;
  & > div {
    border-left: 1px solid #489a4c;
  }
  z-index: 10;
  background-color: #4caf50;
}

.tin-mini-menu {
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  span {
    margin: 0;
  }
}

.tin-user {
  // width: 170px;
  /* background: url("/bg.jpg") 0 0 / 100% 100%; */
  padding: 0 20px;
  /* border-top: 1px solid #f2f2f2; */
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background-color: inherit;
  z-index: 10;
  position: relative;
}
.tin-user:hover,
.tin-mini-menu:hover {
  background-color: #37803a;
}

.tin-user img {
  width: 35px;
  height: 35px;
  border: 2px solid #f2f2f2;
  border-radius: 50px;
  background-color: #fff;
}

.tin-user-info {
  font-size: 18px;
  margin-left: 10px;
  /* padding-top: 2px; */
  color: #fff;
}

.tin-user-tag {
  display: inline-block;
  margin-top: 2px;
  background-color: #ff9800;
  color: #fff;
  font-size: 12px;
  padding: 2px 5px;
  border-radius: 10px;
  display: inline-block;
}
.tin-user-info-boxs {
  position: absolute;
  top: 40px;
  left: 0;
  right: 5px;
  display: none;
  z-index: 2001;
}
.tin-user-info-box {
  background-color: #fff;
  border: 1px solid #ddd;
  position: relative;
  margin-top: 8px;
  padding: 10px;
  // height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.color1 {
  border: 1px solid red;
}
.tin-user-info-box img {
  width: 50px;
  height: 50px;
  display: block;
}

.tin-user-info-box::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: transparent transparent #ddd transparent;
  top: 0;
  left: 50%;
  margin: -12px 0 0 -6px;
  z-index: 1;
}

.tin-user:hover {
  /* background-color: rgba(0, 0, 0, 0.1); */
}
.tin-user:hover .tin-user-info-boxs {
  display: block;
}

.tin-user-buttom {
  height: 26px;
  line-height: 26px;
  text-align: center;
  /* margin: 10px; */
  width: 100%;
  font-size: 13px;
  border-radius: 3px;
  border: 1px solid #ddd;
  background-color: #fff;
  margin-top: 5px;
}

.tin-user-buttom:hover {
  background-color: #f2f2f2;
}

.tu-icon {
  font-size: 24px;
  font-style: normal;
}

.tu-menu-item-text {
  display: inline-block;
  margin-left: 5px;
}

@media screen and (max-width: 1100px) {
  .tu-menu-item-text {
    display: none;
  }

  li:hover .tu-menu-item-text {
    display: inline-block;
  }

  li.active .tu-menu-item-text {
    display: inline-block;
  }
}
</style>
